<template>
  <BaseSimuladorIndicadorModal
    ref="baseModal"
    :modal-id="modalId"
    title="Simulador"
    numerador-label="Numerador"
    denominador-label="Denominador"
    :valor-numerador="nManual"
    :valor-denominador="dManual"
    :base-numerador="baseNumerador"
    :base-denominador="baseDenominador"
    :procedimentos-numerador="PROCEDIMENTOS_NUMERADOR"
    :procedimentos-denominador="PROCEDIMENTOS_DENOMINADOR"
    :tipos="TIPOS_CLASSIFICACAO"
    :calculate-result-fn="calcularResultado"
    :calculate-class-fn="calcularClasse"
    :apply-preset-fn="aplicarPreset"
    :format-delta-fn="formatDelta"
    :result-text-fn="montarTextoResultado"
    hint="💡 Os botões preenchem valores de exemplo. Ajuste manualmente pelos controles acima."
    @update:numerador="setNumerador"
    @update:denominador="setDenominador"
  />
</template>

<script>
import BaseSimuladorIndicadorModal from '@/pages/IndicadoresAps/components/BaseSimuladorIndicadorModal.vue'

export default {
  name: 'SimuladorOdontoModal',
  components: {
    BaseSimuladorIndicadorModal,
  },
  props: {
    modalId: {
      type: String,
      default: 'simulador-odonto-modal',
    },
    dadosPercentualMunicipio: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualEquipe: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualMicroArea: {
      type: Object,
      default: () => ({}),
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nManual: 0,
      dManual: 1,
      baseNumerador: 0,
      baseDenominador: 1,
      TIPOS_CLASSIFICACAO: [
        { value: 'Ótimo', label: 'Ótimo', description: '>= 80 e <= 85' },
        { value: 'Bom', label: 'Bom', description: '>= 60 e < 80' },
        {
          value: 'Suficiente',
          label: 'Suficiente',
          description: '>= 40 e < 60',
        },
        { value: 'Regular', label: 'Regular', description: '< 40 ou > 85' },
      ],
      PROCEDIMENTOS_NUMERADOR: [
        {
          icon: null,
          codigo: '01.01.02.005-8',
          desc: 'Aplicação de cariostático (por dente)',
        },
        {
          icon: null,
          codigo: '01.01.02.006-6',
          desc: 'Aplicação de selante (por dente)',
        },
        {
          icon: null,
          codigo: '01.01.02.007-4',
          desc: 'Aplicação tópica de flúor (individual por sessão)',
        },
        {
          icon: null,
          codigo: '01.01.02.008-2',
          desc: 'Evidenciação de placa bacteriana',
        },
        {
          icon: null,
          codigo: '01.01.02.009-0',
          desc: 'Selamento provisório de cavidade dentária',
        },
        {
          icon: null,
          codigo: '01.01.02.010-4',
          desc: 'Orientação de higiene bucal',
        },
      ],
      PROCEDIMENTOS_DENOMINADOR: [
        {
          icon: null,
          codigo: null,
          desc: 'Procedimentos realizados em Atendimento Odontológico Individual por Cirurgião-Dentista.',
        },
        {
          icon: null,
          codigo: null,
          desc: 'Procedimentos realizados em Atendimento Odontológico Individual por Técnico em Saúde Bucal.',
        },
      ],
    }
  },
  methods: {
    open() {
      this.aplicarFonte()
      this.$refs.baseModal.open()
    },

    close() {
      this.$refs.baseModal.close()
    },

    aplicarFonte() {
      let fonte = this.dadosPercentualMunicipio

      if (this.selectedMicroArea) {
        fonte = this.dadosPercentualMicroArea
      } else if (this.selectedEquipe) {
        fonte = this.dadosPercentualEquipe
      }

      const numerador = Number(fonte?.numerador) || 0
      const denominador = Number(fonte?.denominador) || 1

      this.nManual = numerador
      this.dManual = denominador
      this.resetBase()
    },

    setNumerador(valor) {
      this.nManual = valor
    },

    setDenominador(valor) {
      this.dManual = valor
    },

    resetBase() {
      this.baseNumerador = this.nManual
      this.baseDenominador = this.dManual
    },

    calcularResultado({ numerador, denominador }) {
      const d = Number(denominador) || 0
      if (d <= 0) return 0

      const n = Number(numerador) || 0
      return Number(((n / d) * 100).toFixed(2))
    },

    calcularClasse({ resultado }) {
      if (resultado >= 80 && resultado <= 85) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado >= 60 && resultado < 80) {
        return { nivel: 'Bom', variant: 'success' }
      }
      if (resultado >= 40 && resultado < 60) {
        return { nivel: 'Suficiente', variant: 'warning' }
      }
      if (resultado < 40 || resultado > 85)
        return { nivel: 'Regular', variant: 'danger' }

      return { nivel: 'Regular', variant: 'danger' }
    },

    aplicarPreset({ tipo, setNumerador, setDenominador }) {
      if (tipo === 'Ótimo') {
        setNumerador(80)
        setDenominador(100)
      } else if (tipo === 'Bom') {
        setNumerador(60)
        setDenominador(100)
      } else if (tipo === 'Suficiente') {
        setNumerador(40)
        setDenominador(100)
      } else {
        setNumerador(39)
        setDenominador(100)
      }

      this.$nextTick(() => {
        this.resetBase()
      })
    },

    formatDelta(val) {
      if (val > 0) return `+${val}`
      if (val < 0) return `${val}`
      return ''
    },

    montarTextoResultado({ resultado }) {
      return `NM / DN × 100`
    },
  },
}
</script>
